<script>
import amountCpn from './price-super-sctipt.vue'

export default {
  name: 'learn-more-component-common-add-content',
  components: { amountCpn },
  props: {
    config: {
      required: true,
    },
  },
  computed: {
    btnLabel() {
      const btnLabelKey = this.config.buttonText || this.config.addOns?.buttonText
      return btnLabelKey ? this.$t(btnLabelKey) : ''
    },
  },
  methods: {
    handeleAddPlan(evt) {
      this.$emit('add', evt)
    },
  }
}
</script>
<template>
  <div class="addon-modal__container-body__add">
    <div class="addon-modal__container-body__price">
      <div class="addon-modal__container-body__price-container">
        <amount-cpn :price="config.priceInfo.formattedMonthlyAmount" />
        <div style="display: inline; font-size: 14px;">
          {{ $t(config.priceInfo.monthlyUnit) }}
        </div>
      </div>
      <div class="addon-modal__container-body__price-container">
        <amount-cpn :price="config.priceInfo.formattedAnnualAmount" />
        <div style="display: inline; font-size: 14px;">
          {{ $t(config.priceInfo.annualUnit) }}
        </div>
      </div>
    </div>

    <div class="addon-modal__container-body__btn-row">
      <zm-button data-testid="checkout-button-29" class="buy-plan-btn addon-modal__container-body__btn text-capitalize" @click="handeleAddPlan">
        {{ btnLabel }}
      </zm-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';
@import './common-variables.scss';

.addon-modal__container-body__price {
  margin-bottom: 16px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 16px;
  color: #666487;

  @include media(mobile) {
    & > div:only-child {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
    }
  }

  ::v-deep .bp-add-on-amount {
    display: inline-flex;
    align-items: baseline;

    .bp-add-on-amount__main,
    .bp-add-on-amount__ss {
      font-family: Happy Display;
    }

    .bp-add-on-amount__main {
      font-size: 32px;
      font-weight: 600;

      &.bp-add-on-amount__unit {
        font-size: 14px;
        font-weight: 400;
        position: relative;
        top: -13px;
      }
    }

    .bp-add-on-amount__ss {
      position: relative;
      top: -15px;
    }
  }

  &-container:nth-child(2) {
    padding-left: 16px;
    border-left: 1px solid #e0e0e6;

    .wrap & {
      padding-left: 0;
      border-left: none;
    }
  }
}

.addon-modal__container-body__btn-row {
  margin-bottom: 16px;

  ::v-deep .zm-button__slot {
    @include media(mobile) {
      justify-content: center;
    }
  }
}

/deep/ .addon-modal__container-body__btn {
  padding: 10px 24px;
  color: $background-bg-default;
  background-color: $color-blue;
  border: 1px solid $color-blue;
  border-radius: 999px;
  width: fit-content;

  &:hover,
  &:active,
  &:focus {
    border-color: #0956b5;
    background-color: #0956b5;
    color: #fff;
  }

  &.is-disabled {
    background-color: #f7f9fa !important;
    color: #6e7680 !important;
    border-color: transparent !important;
  }

  &.custom-btn {
    background-color: #ffffff;
    color: #0b5cff;
    border: 1px solid #0b5cff;
  }
}
</style>
